import React from 'react'
import { SelectProps } from 'antd'
import EntitySelect from '../../../shared/components/EntitySelect'
import { useSuppliers } from '../queries/useCtxSuppliers'

interface SupplierSelectProps extends Omit<SelectProps<string>, 'options'> {
  companyId?: string
  // Supplier ids to hide (e.g. already picked elsewhere).
  excludeValues?: string[]
}

/**
 * Select over a company's suppliers. Fetches its own data; shows "Ladataan…" instead of the raw id
 * while the list loads, and "Poistettu" if the selected supplier no longer exists.
 */
const SupplierSelect: React.FC<SupplierSelectProps> = ({ companyId, excludeValues, ...selectProps }) => {
  const { data: suppliers = [], isLoading } = useSuppliers(companyId)

  return <EntitySelect entities={suppliers} loading={isLoading} excludeValues={excludeValues} {...selectProps} />
}

export default SupplierSelect
